import React from 'react'
import { Modal, Select, Input, Form } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input

// Small popup to edit a single field (condition | remarks) of one Asset Stock
// Taking asset detail. Pre-filled with the current value.
class EditFieldModal extends React.Component {
  state = {
    value: undefined,
  }

  componentDidUpdate (prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ value: this.props.currentValue })
    }
  }

  handleOk = () => {
    const { field } = this.props
    const value = this.state.value
    if (field === 'condition' && !value) {
      return Modal.error({ title: 'Condition required', content: 'Please select a condition of asset.' })
    }
    this.props.onSave(field, value)
  }

  renderField () {
    const { field, conditionOptions } = this.props
    const { value } = this.state

    if (field === 'condition') {
      return (
        <Select
          showSearch
          allowClear
          style={{ width: '100%' }}
          value={value}
          placeholder='Please Select Condition Of Asset'
          onChange={(v) => this.setState({ value: v })}
          filterOption={(input, option) =>
            (option.props.children + '').toLowerCase().indexOf((input + '').toLowerCase()) >= 0
          }
        >
          {(conditionOptions || []).map((option) => (
            <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>
          ))}
        </Select>
      )
    }

    // remarks
    return (
      <TextArea
        rows={3}
        style={{ width: '100%' }}
        value={value || ''}
        placeholder='Remarks'
        onChange={(e) => this.setState({ value: e.target.value })}
      />
    )
  }

  render () {
    const { visible, title, onCancel, confirmLoading } = this.props
    return (
      <Modal
        title={title || 'Edit'}
        visible={visible}
        onOk={this.handleOk}
        onCancel={onCancel}
        okText='Save'
        confirmLoading={confirmLoading}
        destroyOnClose
      >
        <Form layout='vertical'>
          <FormItem label={title}>
            {this.renderField()}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default EditFieldModal
